import { array, number, object, string } from "yup";

export const OPTIONS_OPERATOR = [
    { label: "AND", value: "AND" },
    { label: "OR", value: "OR" }
];

export const OPTIONS_ATTRIBUTE = [{ label: "MRR", value: "mrr" }];

export const OPTIONS_CONDITION = [
    { label: "Greater Than", value: "greater_than" },
    { label: "Lower Than", value: "lower_than" },
    { label: "Equal To", value: "equal_to" }
];

export const validationSchema = object().shape({
    name       : string().required("Name is required"),
    description: string(),
    operator   : string().required("Operator is required"),
    conditions : array().of(
        object().shape({
            attribute         : string().required("Attribute is required"),
            attributeCondition: string().required("Condition is required"),
            attributeValue    : number().required("Value is required")
        })
    ).min(1, "At least one condition is required")
});